<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Novo Grupo de Ferramenta
      </p>
    </div>
    <q-form ref="myForm">
      <div class="row col-12 q-col-gutter-sm q-mt-sm">
        <div
          class="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Unidade
          <lista-unidades-select v-model="unidade"></lista-unidades-select>
        </div>
        <div
          class="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Nome do Grupo
          <q-input dense outlined v-model="grupo.nome" />
        </div>

        <div
          class="col-xs-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Descrição
          <q-input dense outlined v-model="grupo.descricao" />
        </div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12">
          <p></p>
          <q-btn
            class="q-mt-sm full-width"
            color="positive"
            label="Adicionar"
            type="submit"
            no-caps
            :disable="disable"
            icon="add"
            @click.prevent="criar()"
          />
        </div>
      </div>
    </q-form>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Grupos de Ferramentas
        </span>
        <div
          class="row col-md-12 col-xs-12 justify-end text-brand-5 text-weight-bold q-mb-lg container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtraFerramenta"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        id="customers"
        class="q-mt-sm tabela-tamanho-fixo"
        :rows="listaGrupos"
        :columns="columns"
        dense
        :rows-per-page-options="[0]"
        :loading="loading"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        v-model:selected="selected"
        v-model:pagination="pagination"
        hide-pagination
        flat
        row-key="uuid"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <span v-if="!props.selected"> {{ props.row.nome }}</span>
              <q-input
                dense
                outlined
                v-else
                v-model="props.row.nome"
                style="width: 110px"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected"> {{ props.row.descricao }}</span>
              <q-input
                dense
                outlined
                v-else
                v-model="props.row.descricao"
                style="width: 140px"
              />
            </q-td>
            <q-td>
              <q-btn
                v-if="!props.selected"
                icon="edit"
                color="black"
                round
                flat
                @click="
                  (props.selected = !props.selected),
                    recebeDadosCategoria(props.row)
                "
              />
              <q-btn
                v-else
                icon="done"
                color="positive"
                round
                flat
                @click="editarCategoria(props.row)"
              />
            </q-td>
            <q-td>
              <router-link
                :to="{
                  name: 'detalhar-grupo',
                  params: {
                    uuid: props.row.uuid,
                    unidadeId: emitir.unidade?.id,
                  },
                }"
              >
                <q-btn
                  flat
                  icon="add_circle"
                  color="blue-6"
                  round
                  size="lg"
                ></q-btn>
              </router-link>
            </q-td>
            <q-td>
              <q-btn
                flat
                style="color: red"
                icon="remove_circle_outline"
                round
                @click="confirmarDeletar(props.row.uuid)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card style="width: 600px; height: 200px">
        <q-card-section class="row items-center">
          <q-avatar icon="info" color="red" text-color="white" />
          <span class="q-ml-sm">Deseja realmente excluir o grupo?</span>
        </q-card-section>

        <q-card-actions class="justify-around items-end">
          <q-btn
            flat
            icon="close"
            size="lg"
            round
            color="negative"
            v-close-popup
          />
          <q-btn
            round
            size="lg"
            flat
            color="positive"
            v-close-popup
            @click="deletar()"
            icon="done"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <DialogConfirmDesign
      :exibir="modalDeletar"
      mensagem="Tem certeza que deseja remover esse Grupo?"
      @resultado="handleDeletarConfirmacao"
    />
  </q-page>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../components/DialogConfirmDesign.vue";

export default {
  components: { ListaUnidadesSelect, DialogConfirmDesign },
  name: "CadastrarGrupo",
  setup() {
    let loading = ref(true);
    const unidade = ref();
    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      dataInicio: new Date().toLocaleString("pt-br"),
      dataTermino: new Date().toLocaleString("pt-br"),
    });

    const filtraFerramenta = ref("");
    const modalDeletar = ref(false);
    const uuidParaDeletar = ref(null);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });
    const grupo = ref({
      unidadeId: "",
      uuid: "",
      nome: "",
      descricao: "",
    });
    let disable = ref(false);
    const listaGrupos = ref([]);
    const $q = useQuasar();
    const myForm = ref(null);
    const store = useStore();
    const router = useRouter();
    const dados = ref({
      uuid: "",
      nome: "",
    });
    const dadosCategoria = ref({
      descricao: "",
      nome: "",
    });
    const columns = [
      {
        name: "nome",
        label: "Nome do Grupo",
        field: "nome",
        align: "left",
        sortable: true,
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
        sortable: false,
      },
      {
        name: "editar",
        label: "Editar",
        field: "",
        align: "left",
      },
      {
        name: "detalhar",
        label: "Detalhes",
        field: "",
        align: "left",
      },
      {
        name: "remover",
        label: "Remover",
        field: "",
        align: "left",
      },
    ];
    const selected = ref([]);

    const editar = async (uuid) => {
      router.push({ name: "editarGrupo", params: { uuid } });
    };

    const listarCategorias = async (page = 1, rowsPerPage = 6) => {
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch("fer/listarCategorias", {
          page: page,
          per_page: rowsPerPage,
          nome: filtraFerramenta.value,
        });
        listaGrupos.value = response.data.result.data;
        pagination.value.rowsPerPage = response.data.result.per_page;
        pagination.value.rowsNumber = response.data.result.total;
        pagination.value.page = response.data.result.current_page;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const confirmarDeletar = (uuid) => {
      uuidParaDeletar.value = uuid;
      modalDeletar.value = true;
    };

    const handleDeletarConfirmacao = async (confirmado) => {
      modalDeletar.value = false;
      if (confirmado) {
        await deletar(uuidParaDeletar.value);
      }
      uuidParaDeletar.value = null;
    };

    let deletar = async (uuid) => {
      try {
        loading.value = true;
        await store.dispatch("fer/deletarCategoria", {
          categoriaUuid: uuid,
        });
        $q.notify({
          message: "Grupo excluido!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loading.value = false;
        listarCategorias();
      } catch (error) {
        $q.notify({
          message: error.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loading.value = false;
      }
    };

    const recebeDadosCategoria = (categoria) => {
      dadosCategoria.value = {
        nome: categoria.nome,
        descricao: categoria.descricao,
      };
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        emitir.value.unidade = store.state.org.unidadeData;
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      emitir.value.unidade = store.state.org.unidadeData;
    };

    const handleRequest = async () => {
      listarCategorias(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtraFerramenta.value,
      () => {
        handleRequest();
      }
    );

    onMounted(() => {
      getUnidade();
      listarCategorias();
    });

    const criar = async () => {
      if (grupo.value.nome == "") {
        $q.notify({
          message: "Preencha o nome do Grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (grupo.value.descricao == "") {
        $q.notify({
          message: "Preencha a descrição do Grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("fer/criarCategoria", {
          nome: grupo.value.nome,
          descricao: grupo.value.descricao,
        });

        $q.notify({
          message: "Grupo Cadastrado!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        onReset();
        listarCategorias();
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.errors) {
            $q.notify({
              message: e.response.data.errors[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
      loading.value = false;
      disable.value = false;
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      grupo.value = {};
    };

    const editarCategoria = async (categoria) => {
      if (
        dadosCategoria.value.nome == categoria.nome &&
        dadosCategoria.value.descricao == categoria.descricao
      ) {
        selected.value = [];
        return;
      }
      try {
        await store.dispatch("fer/editarCategoria", {
          categoriaUuid: categoria.uuid,
          nome: categoria.nome,
          descricao: categoria.descricao,
        });

        $q.notify({
          message: "Grupo alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        selected.value = [];
        listarCategorias();
      } catch (error) {
        $q.notify({
          message: "Erro ao alterar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    onMounted(listarCategorias);

    return {
      criar,
      editar,
      deletar,
      myForm,
      listaGrupos,
      handleRequest,
      pagination,
      columns,
      emitir,
      getUnidade,
      grupo,
      confirm: ref(false),
      dados,
      loading,
      unidade,
      disable,
      filtraFerramenta,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      recebeDadosCategoria,
      selected,
      editarCategoria,
      dadosCategoria,
      modalDeletar,
      confirmarDeletar,
      handleDeletarConfirmacao,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
</style>
